import { useChartData } from '../../context/ChartContext';
export function getTwoDimensionPhaseCorrectionOptions(state) {
    const { toolOptions: { data: { twoDimensionPhaseCorrection: { traces, activeTraceDirection, addTracesToBothDirections, }, }, }, } = state;
    return {
        activeTraces: traces[activeTraceDirection],
        traces,
        activeTraceDirection,
        addTracesToBothDirections,
    };
}
export function useTwoDimensionPhaseCorrectionOptions(direction) {
    const { toolOptions: { data: { twoDimensionPhaseCorrection: { traces }, }, }, } = useChartData();
    return traces[direction];
}
